module.exports = __webpack_public_path__ + "media/images/payment_methods/inghomepay-384d661a51e34c1ac026d53cc6e9d95a.svg";